import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

import { ProgressBar, Title, SubTitle } from './components'
import FooterButton from 'components/modules/common/FooterButton'

const OnboardingStep2 = () => {
  const history = useHistory()

  const [habit, setHabit] = useState(null) // pill, water, walk

  const handleHabitClick = (clickedHabit) => {
    if (clickedHabit === habit) {
      setHabit(null)
    } else {
      setHabit(clickedHabit)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const isValid = ['pill', 'water', 'walk'].includes(habit)

  return (
    <Container>
      <ProgressBarWrapper>
        <ProgressBar currentStep={2} />
      </ProgressBarWrapper>

      <TitleWrapper>
        <Title>
          처음은 작게 시작하기.
          <br />
          만들고 싶은 습관을 골라주세요!
        </Title>
        <SubTitle>3일만 일단 시작해 보세요</SubTitle>
      </TitleWrapper>

      <Content>
        <HabitList>
          <Habit habit={'pill'} isSelected={habit === 'pill'} onClick={handleHabitClick} />
          <Habit habit={'water'} isSelected={habit === 'water'} onClick={handleHabitClick} />
          <Habit habit={'walk'} isSelected={habit === 'walk'} onClick={handleHabitClick} />
        </HabitList>
      </Content>

      <FooterButton
        isValid={isValid}
        onComplete={() => {
          if (!isValid) {
            return
          }
          history.push('/onboarding/step3', { habit })
        }}
      >
        선택 완료!
      </FooterButton>
    </Container>
  )
}

const Container = styled.div`
  padding: 24px 20px 36px;
  position: relative;
  height: 100vh;
`

const ProgressBarWrapper = styled.div`
  margin-bottom: 36px;
`

const TitleWrapper = styled.div`
  margin-bottom: 57px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const HabitList = styled.div``

const Habit = ({ habit, isSelected = false, onClick }) => {
  return (
    <HabitItem isActive={isSelected} onClick={() => onClick(habit)}>
      {habit === 'pill'
        ? '💊 영양제 먹기 3일 챌린지'
        : habit === 'water'
        ? '💧 물마시기 3일 챌린지'
        : habit === 'walk'
        ? '🏃‍♂️ 산책하기 3일 챌린지'
        : ''}
    </HabitItem>
  )
}

const HabitItem = styled.div`
  width: calc(100vw * (300 / 375));
  height: calc(100vw * (82 / 375));
  background-color: ${({ isActive }) => (isActive ? '#FFF4D8' : '#FFFBF0')};
  border: ${({ isActive }) => (isActive ? '2px solid #FFCF19' : 'none')};
  border-radius: calc(100vw * (15 / 375));
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: calc(100vw * (18 / 375));
  line-height: calc(100vw * (26 / 375));
  color: ${({ isActive }) => (isActive ? '#373737' : '#4E4E4E')};

  :not(:last-child) {
    margin-bottom: 22px;
  }
`
export default OnboardingStep2
